<template>
    <div class="upsell-payment-summary">
        <!-- SUBSCRIPTION -->
        <template v-if="step === 0">
            <ChargebeeUpsellSummaryItemsV3
                v-if="getIsPricingVersion3"
                class="upsell-payment-summary-subscription"
            />
            <ChargebeeUpsellSummaryItems
                v-else
                :data="getSubscriptionItems"
                class="upsell-payment-summary-subscription"
            />
        </template>

        <!-- INCOMING SUBSCRIPTION-->
        <div class="upsell-payment-summary-incoming">
            <h2 class="upsell-payment-summary-heading typographies-paragraph-large-bold">
                <span>{{ $l10n.__('Abonnement') }}</span>
                <div>
                    <span class="typographies-paragraph-large-black">
                        {{
                            $filters.numberFormatCurrency(
                                humanizeCentsPrice(getSubscriptionIncoming.heading.price),
                            )
                        }}
                    </span>
                    <span class="typographies-paragraph-medium-bold">
                        /{{ recurrencyLabel(getRecurrence) }}
                    </span>
                </div>
            </h2>
            <ul class="upsell-payment-summary-listing">
                <li
                    v-for="(item, index) in getSubscriptionIncoming.items"
                    :key="index"
                    class="upsell-payment-summary-listing__item typographies-paragraph-medium-regular"
                >
                    <span class="upsell-payment-summary-listing__item-label">
                        {{ item.label }}
                    </span>
                    <div class="upsell-payment-summary-listing__item-price">
                        <span class="typographies-paragraph-medium-bold">
                            {{ $filters.numberFormatCurrency(humanizeCentsPrice(item.price)) }}
                        </span>
                        <span class="typographies-paragraph-small-regular">
                            /{{ recurrencyLabel(item.recurrence) }}
                        </span>
                    </div>
                </li>
            </ul>
        </div>

        <!-- INVOICE -->
        <div class="upsell-payment-summary-invoicing">
            <h2 class="upsell-payment-summary-heading typographies-paragraph-large-bold">
                <span>{{ $l10n.__('Facturable maintenant') }}</span>
                <div>
                    <span class="typographies-paragraph-large-black">
                        {{
                            $filters.numberFormatCurrency(
                                humanizeCentsPrice(getSubscriptionInvoicing.heading.price),
                            )
                        }}
                    </span>
                </div>
            </h2>
            <ul
                v-if="getSubscriptionInvoicing.items.length > 0"
                class="upsell-payment-summary-listing"
            >
                <li
                    v-for="(item, index) in getSubscriptionInvoicing.items"
                    :key="index"
                    class="upsell-payment-summary-listing__item typographies-paragraph-medium-regular"
                >
                    <span class="upsell-payment-summary-listing__item-label">
                        {{ item.label }}
                    </span>
                    <div class="upsell-payment-summary-listing__item-price">
                        <span class="typographies-paragraph-medium-bold">
                            {{ $filters.numberFormatCurrency(humanizeCentsPrice(item.price)) }}
                        </span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import ChargebeeUpsellSummaryItems from 'vcomponents/pages/account/upsell/ChargebeeUpsellSummaryItems.vue';
import ChargebeeUpsellSummaryItemsV3 from 'vcomponents/pages/account/upsell/pricingVersion3/ChargebeeUpsellSummaryItemsV3.vue';
import ChargebeeUpsellMixin from 'mixins/chargebee/ChargebeeUpsellMixins';
import { createNamespacedHelpers } from 'vuex';
const chargebeeUpsellStore = createNamespacedHelpers('chargebeeUpsellStore');

export default {
    components: { ChargebeeUpsellSummaryItems, ChargebeeUpsellSummaryItemsV3 },
    mixins: [ChargebeeUpsellMixin],
    props: {
        step: {
            type: Number,
            required: true,
        },
    },
    computed: {
        ...chargebeeUpsellStore.mapGetters([
            'getSubscriptionItems',
            'getRecurrence',
            'getSubscriptionInvoicing',
            'getSubscriptionIncoming',
            'getIsPricingVersion3',
        ]),
    },
};
</script>

<style lang="scss" scoped>
.upsell-payment-summary {
    display: flex;
    flex-direction: column;

    &-heading {
        display: flex;
        justify-content: space-between;
        margin: 0;
    }

    &-listing {
        margin: 0 0 var(--spacing-2) 0;

        &__item {
            display: flex;
            justify-content: space-between;

            &-label {
                display: flex;
                align-items: center;
            }
        }
    }

    &-subscription {
        padding-bottom: var(--spacing-2);
        border-bottom: 1px solid var(--colors-common-border-default);
    }

    &-incoming {
        margin-top: var(--spacing-2);
    }

    &-invoicing {
        margin-bottom: var(--spacing-2);
        padding-top: var(--spacing-2);
        border-top: 1px solid var(--colors-common-border-default);
    }

    &-incoming,
    &-invoicing {
        .upsell-payment-summary-listing__item-label {
            color: var(--colors-common-text-subtle-default);
        }
    }
}
</style>
